import { useMemo } from 'react';
import { ApolloClient, HttpLink, InMemoryCache, useApolloClient } from '@apollo/client';

import { clientConfig } from '@/config/clientConfig';
import { getBearerToken } from '@/shared/api/utils';
import { useAuthStore } from '@/shared/store/auth.store';

export const useDirectUrlClient = () => {
  const { accessToken } = useAuthStore();
  const defaultGqlClient = useApolloClient();

  const gqlClient = useMemo(() => {
    if (accessToken) {
      return new ApolloClient({
        link: new HttpLink({
          uri: clientConfig.api.directGraphqlUrl,
          headers: {
            authorization: getBearerToken(accessToken) as string,
          },
        }),
        cache: new InMemoryCache(),
      });
    }
    return defaultGqlClient;
  }, [defaultGqlClient, accessToken]);

  return gqlClient;
};
